import { Component, OnInit, EventEmitter } from '@angular/core';
import { CostCenter } from '../share/costCenter/costcenter.model';
import { BsModalRef } from 'ngx-bootstrap';
import { CostCenterService } from '../share/costCenter/costcenter.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators/finalize';
import { CostCenterSummary } from './state.model';
import { AppSettings } from '../../settings';
import { FilterPipe } from '../pipes/filterPipe';
import { Zone } from '../share/zones/zone.model';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-admin-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.css'],
  providers: [CostCenterService, FilterPipe]
})
export class AdminStateComponent implements OnInit {
  costCenters: CostCenter[] = [];
  zones: Zone[] = [];
  costCenterId: number = null;
  zoneId: number = null;
  zoneIds: number[] = [];
  adminCostCenterState: CostCenterSummary;
  adminCostCenterStates: CostCenterSummary[];
  p = 1;
  details = -1;
  isLoadDetails = false;
  searchString: string;
  recordsPerPage: number;
  isLoading = false;
  filterValueChanged: EventEmitter<any> = new EventEmitter();
  currencySuffix: string;
  searchClicked = false;
  filterValue: string;
  order = 'saldoEnd';
  allZones: Zone = new Zone();

  modalRef: BsModalRef;
  constructor(
    private _costCenterService: CostCenterService,
    private _spinner: NgxSpinnerService,
    private _settings: AppSettings,
    private _translate: TranslateService,
    private _toastrService: ToastrService
  ) {
    this.currencySuffix = _settings.getCurrencySuffix(new Date());
    this.recordsPerPage = _settings.recordsPerPage;
  }

  ngOnInit() {
    this.getZones();
  }

  search() {
    this.isLoading = true;
    this._spinner.show();

    if (this.zoneId === -10) {
      this.zoneIds = this.zones.map(z => z.zoneId);
    } else if (this.zoneId != null) {
      this.zoneIds = [];
      this.zoneIds.push(this.zoneId);
    }

    this._costCenterService.httpGetCostCentersState(this.zoneIds)
      .pipe(finalize(() => this._spinner.hide()))
      .subscribe(
        data => {
          if (data !== undefined) {
            this.adminCostCenterStates = data;
            this.searchClicked = true;
          }
        },
        err => {
          throw err;
        }, () => this.isLoading = false
      );
  }

  onClearAllFilters() {
    this.costCenterId = null;
    this.details = -1;
    this.removeFocus();
  }

  removeFocus() {
    (document.activeElement as HTMLElement).blur();
  }

  getNumOfDays(id: number) {
    const lastAccDate = this.adminCostCenterStates.find(x => x.costCenterId === id).lastAccountingTime;
    return Math.round((Date.now() - +(new Date(lastAccDate))) / (1000 * 60 * 60 * 24));
  }

  onCostCenterChange() {
    if (this.zoneId !== null) {
      this.adminCostCenterStates = [];
      this.details = -1;
      this.p = 1;
      this.search();
      this.removeFocus();
    }
  }

  filterBy = (value: string) => {
    this.filterValue = value;
  }

  getZones() {
    this._costCenterService.httpGetZones()
      .pipe(finalize(() => this._spinner.hide()))
      .subscribe(
        data => {
          if (data !== undefined) {
            this.zones = data;

            this._translate.get('AllZones').subscribe(translated => {
              this.allZones.name = translated;
            });
            this.allZones.zoneId = -10;
            this.zones.unshift(this.allZones);
          }
        },
        err => {
          throw err;
        });
  }
  keyDownFunction(event) {
    if (event.key === 'Enter') {
      this.removeFocus();
    }
  }

  filterByOnChange() {
    this.filterValueChanged.emit(this.filterValue);
  }

  sort(propertyName) {
    if (this.details > -1) return;
    if (this.order === propertyName) {
      this.order = '-' + propertyName;
    } else if (this.order === '-' + propertyName) {
      this.order = propertyName;
    } else {
      this.order = propertyName;
    }
  }

  getCurrentSaldoForCostCenter(i: number, costCenterId: number) {
    this.isLoading = true;
    this.details = i;
    this.isLoadDetails = false;
    this._spinner.show();

    this._costCenterService.httpGetCostCenterSummary(costCenterId)
      .pipe(finalize(() => this._spinner.hide()))
      .subscribe(
        data => {
          if (data !== undefined) {
            this.adminCostCenterState = Object.assign(new CostCenterSummary(), data);
            this.isLoadDetails = true;
          }
        },
        err => {
          if (err.error['errorCode'] === 'NotFound') {
            this._translate.get('Messages.TerminalNotFoundError').subscribe(translated => {
              this._toastrService.error(translated);
              this.isLoading = false;
            });
          } else {
            this._translate.get('Messages.TerminalSummaryError').subscribe(translated => {
              this._toastrService.error(translated);
            });
          }
          this.details = -1;
          throw err;
        }, () => this.isLoading = false
      );
  }

  onSearchTextChange(): void {
    if (this.details !== -1) {
      this.isLoadDetails = false;
      this.details = -1;
    }
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/admin-state/state.component.ts